import type { UseMutationResult } from '@tanstack/react-query';

import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { SfAccount } from '../../api/types/sfRedirect.types';

import { importSfAccount } from '../../api/import-sf-account/importSfAccount';

export function useImportSfAccount(): UseMutationResult<
  SfAccount,
  Error,
  string
> {
  const queryClient = useQueryClient();

  return useMutation<SfAccount, Error, string>({
    mutationFn: (sfAccountId: string): Promise<SfAccount> =>
      importSfAccount(sfAccountId),
    onSuccess: (data: SfAccount, sfAccountId: string): void => {
      queryClient.setQueryData(['sf-account', sfAccountId], data);
    },
  });
}
